import { render } from "./distributorstockForm.vue?vue&type=template&id=137ef46e&scoped=true"
import script from "./distributorstockForm.vue?vue&type=script&lang=js"
export * from "./distributorstockForm.vue?vue&type=script&lang=js"

import "./distributorstockForm.vue?vue&type=style&index=0&id=137ef46e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-137ef46e"]])

export default __exports__